import React from 'react';
import ImageUploading from 'react-images-uploading';
import type { ImageListType } from 'react-images-uploading';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import EditIcon from '@material-ui/icons/Edit';
import styles from '../furnishingContainer.module.scss';

interface ImageUploaderProps {
  images: ImageListType;
  onImageChange: (imageList: ImageListType) => void;
  existingImageUrl?: string;
  maxNumber?: number;
  multiple?: boolean;
  altText?: string;
  minImages?: number;
}

export const ImageUploader: React.FC<ImageUploaderProps> = ({
  images,
  onImageChange,
  existingImageUrl,
  maxNumber = 1,
  multiple = false,
  altText = 'Upload',
  minImages = 0
}) => {
  const canRemoveImage = images?.length > minImages;
  return (
    <ImageUploading
      value={images}
      onChange={onImageChange}
      maxNumber={maxNumber}
      multiple={multiple}
      dataURLKey="dataURL"
    >
      {({ imageList, onImageUpload, onImageUpdate, onImageRemove, isDragging, dragProps }) => (
        <div className={styles['upload-image-wrapper']}>
          {!multiple && imageList.length > 0 ? (
            <div className={styles['image-container']}>
              <img src={imageList[0].dataURL} alt={altText} />
              <div className={styles['image-controls']}>
                <button type="button" onClick={() => onImageUpdate(0)}>
                  <EditIcon />
                </button>
              </div>
            </div>
          ) : !multiple && existingImageUrl ? (
            <div className={styles['image-container']}>
              <img src={existingImageUrl} alt={altText} />
              <div className={styles['image-controls']}>
                <button type="button" onClick={onImageUpload}>
                  <EditIcon />
                </button>
              </div>
            </div>
          ) : (
            <>
              <div
                className={styles.dropzone}
                {...dragProps}
                onClick={onImageUpload}
                onKeyDown={(e: React.KeyboardEvent) => e.key === 'Enter' && onImageUpload()}
                role="button"
                tabIndex={0}
                style={isDragging ? { borderColor: '#4a90e2' } : undefined}
              >
                <CloudUploadIcon fontSize="large" />
                <span>Click or drag to upload {multiple ? 'images' : 'an image'}</span>
              </div>
              {multiple && imageList.length > 0 && (
                <div className={styles['furnishing-management__images-grid']}>
                  {imageList.map((image, imgIndex) => (
                    <div
                      key={image.dataURL || `img-${imgIndex}`}
                      className={styles['furnishing-management__image-item']}
                    >
                      <img src={image.dataURL} alt={`${altText} ${imgIndex + 1}`} />
                      {canRemoveImage && (
                        <button
                          type="button"
                          onClick={() => onImageRemove(imgIndex)}
                          className={styles['furnishing-management__remove-image-btn']}
                          title="Remove image"
                          aria-label={`Remove image ${imgIndex + 1}`}
                        >
                          ×
                        </button>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </>
          )}
        </div>
      )}
    </ImageUploading>
  );
};
